<div class="fb-norway-eol-card-plugin" hive-root>
    <div class="fb-norway-eol-card-plugin__icon">
        <svg hive-svg="rec-foundation.svg" [height]="28"></svg>
    </div>

    <div class="fb-norway-eol-card-plugin__text">
        <p class="hive-paragraph-small hive-paragraph-regular fb-norway-eol-card-plugin__message">
            This FlashBlade appliance is approaching the end of life
        </p>

        <div class="fb-norway-eol-card-plugin__days-remaining">
            @let daysLeft = renderInfo().eolDate | daysUntil;
            <p class="fb-norway-eol-card-plugin__days-remaining-text">
                in <span class="fb-norway-eol-card-plugin__days-left">{{ daysLeft }}</span>
                {{ daysLeft === 1 ? 'Day' : 'Days' }}
            </p>
        </div>

        <p class="hive-paragraph-small hive-paragraph-regular fb-norway-eol-card-plugin__call-to-action">
            Contact your account team to upgrade
        </p>
    </div>
</div>
